import { green } from "@ant-design/colors";
import { ThemeConfig } from "antd";

export const stateButtonTheme: ThemeConfig = {
  components: {
    Button: {
      colorPrimary: green[5],
      colorPrimaryHover: green[3],
      colorPrimaryActive: green[7],
    },
  },
};
